import {LocaleContents} from "../types/types"

export const nl_NL: LocaleContents = {
    title: 'WINTERSPORT BOEKEN 2023-2024',
    datepicker: {
        daysOfWeek: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
        monthNames: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
        firstDay: 1,
        winter: "Winter"
    },
    promoImg: 'https://www.travelski.com/Content/fr_220209145533_6203d5e5e8a4025b233b5867.png?ts=220209145949',

    startDate: 'Aankomstdatum',
    endDate: 'Vertrekdatum',

    participants: 'Reizigers',
    adults: 'Volwassenen',
    adult: 'Volwassene',
    children: 'Kinderen',
    child: 'Kind',
    childrenAgeAtTheStartOfStay: 'Leeftijd van reiziger op de aankomstdag',
    participantsSign: 'Voer de leeftijden van de reizigers in zodat we je de meest nauwkeurige prijzen kunnen aanbieden.',
    saveParticipants: 'Bevestig reisgezelschap',
    numParticipants: 'Samenstelling reisgezelschap',
    placeHolders: {
        domains: 'skigebieden',
        regions: "Regio's",
        stations: 'dorpen',
        packages: 'Skipakket',
        lodgingType: 'Soort accommodatie',
        autocomplete: " Regio's, skigebieden, dorpen, accommodaties...",
        autocompleteSummer: " Regio's, dorpen, accommodaties...",
        topStations: 'Top stations',
        accommodations: 'Accommodaties',
        noResults: 'Geen resultaat voor'
    },

    search: 'Zoek',
    reset: 'Herstel',
    topStations: '',
    package: {
        days: "",
        title_PF: "",
        title_PFP: "",
        accomodation: "",
        skipass: "",
        equipment: "",
    },
}